import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import {
  DetalleExpediente, ElasticExpedientesByKeyword, ExpedienteFiltroDTO,
  Expedientes, FiltroAZ, HistorialSolicitudes, IResultadoDocument, IResultadoSearch, UnidadDocumental, SearchOperators, ExportExpedientes,
  InventoryIdenty, UnidadDocumentalSimple, AZ, Contenedores, ResponseAddRelacionContenidoUnidadDocumental, TIPO_DOCUMENTAL, ShoppingCart, TypeShoppingCart, ResponseCargaInventario, GrupoOficina
} from '../model/inventories';
import { AzDetail } from '../model/inventory-detail/az-detail';
import { ImagenCacheBufferService } from './imagen-cache-buffer.service';
import { ResponseComprobarIntegridadExpModule } from '../model/ResponseComprobarIntegridadExpModule';
import { ResponseRelacionModule } from '../model/response-relacion.module';
import { ResponseAddRelacionModule } from '../model/response-add-relacion.module';
import { FileData, MassiveLoadResult } from '../model/massive-load-result';
import { FieldsToDraw, FieldsWithDataToPaintModule } from '../model/fields-with-data-to-paint.module';
import { VResponseBatchModule } from '../model/v-response-batch.module';
import { GrupoSSO, InventarioSSO } from '../model/inventario-sso';
import { ExtraerSeriesAlmacen } from '../model/extraser-series-almacen';
import { UnidadSolicitud } from '../model/unidad-solicitud';
import { CampoSolicitud } from '../model/campo-solicitud';
import { ResponseFechas } from '../model/response-fechas';

@Injectable()
export class InventariosService {

  INVENTORIES_PATH = `${environment.API_BASE}/Inventario`;
  PATH_DOWNLOAD = `${environment.API_BASE}/files`;

  private recordsToViewDetails: DetalleExpediente;

  private filter: ExpedienteFiltroDTO;
  private camposRango = false;

  private operatorByKeyword = SearchOperators.OR;
  private activarConsultas = false;
  private consultaOrigen = 0;
  private contenidoOrigen = 0;

  listInventory: string[] = [];

  notUnload = false;

  private filterExtraerSeries: ExpedienteFiltroDTO;

  constructor(
    private http: HttpClient,
    private router: Router,
    private imagenCacheService: ImagenCacheBufferService
  ) {
  }

  isCalledFromConsultas(): boolean {
    return this.consultaOrigen > 0 && this.contenidoOrigen > 0 && this.activarConsultas;
  }

  addImageToConsulta(idRelacion: number, file: File): Observable<boolean> {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post<boolean>(`${this.INVENTORIES_PATH}/SubirImagenConsulta?idRelacion=${idRelacion}`, formData);
  }

  descargarImagenConsulta(idRelacion: number) {
    return this.http.get(`${this.INVENTORIES_PATH}/BajarImagenConsulta?idRelacion=${idRelacion}`, { responseType: 'blob' });
  }

  removeImagenConsulta(guid: string): Observable<boolean> {
    return this.http.get<boolean>(`${this.INVENTORIES_PATH}/RemoveImagenConsulta?imagen=${guid}`);
  }

  getExtension(filename: string): string {
    const splitPoint = filename.split('.');
    return splitPoint[splitPoint.length - 1];
  }

  calculateSizeFile(size: number): string {
    const sizeInKb = Math.ceil(size / 1000);
    if (sizeInKb < 1000) {
      return sizeInKb + ' Kb';
    }

    return Math.ceil(sizeInKb / 1000) + ' Mb';
  }

  addDocumentoConsulta(unidadDocumental: InventoryIdenty, isParcial: boolean, textoParcial: string): Observable<ResponseAddRelacionContenidoUnidadDocumental> {
    let ruta = this.INVENTORIES_PATH + '/RelacionExpCont?idContenido=' + this.contenidoOrigen;
    if (unidadDocumental.tipoDocumental === TIPO_DOCUMENTAL.expediente ||
      unidadDocumental.tipoDocumental === TIPO_DOCUMENTAL.az) {
      ruta = ruta + '&guidExpediente=' + unidadDocumental.id;
    } else if (unidadDocumental.tipoDocumental === TIPO_DOCUMENTAL.contenedor) {
      ruta = ruta + '&idContenedor=' + unidadDocumental.id;
    }
    if (isParcial) {
      ruta = ruta + '&isParcial=' + isParcial;
      if (textoParcial !== undefined && textoParcial !== null) {
        ruta = ruta + '&textoParcial=' + textoParcial;
      }
    }
    return this.http.get<ResponseAddRelacionContenidoUnidadDocumental>(ruta);
  }

  tratarError(errorProducido): string {
    let respuestaServidor = '';
    if (errorProducido instanceof HttpErrorResponse) {
      if (errorProducido.status === 400) {
        respuestaServidor = errorProducido.message;
      }
    }
    return respuestaServidor;
  }

  returnToSolicitud() {
    this.router.navigate(['docout', { outlets: { contenido: ['detalle', this.consultaOrigen] } }]);
    this.restartConsultas();
  }

  restartConsultas() {
    this.consultaOrigen = 0;
    this.contenidoOrigen = 0;
    this.activarConsultas = false;
  }

  comprobarIntegridadExpedienteDocumental(idExpediente: string): Observable<ResponseComprobarIntegridadExpModule> {
    return this.http.get<ResponseComprobarIntegridadExpModule>(
      this.INVENTORIES_PATH + '/ComprobarIntegridadExp?idExp=' + idExpediente);
  }

  getRelacionesContenido(idContenido: number): Observable<FieldsWithDataToPaintModule[]> {
    return this.http.get<FieldsWithDataToPaintModule[]>(
      this.INVENTORIES_PATH + '/GetRelacionContenido?idContenido=' + idContenido
    );
  }

  modifTextoParcialRelacion(idRelacion: number, textoParcial: string): Observable<boolean> {
    return this.http.post<boolean>(
      this.INVENTORIES_PATH + '/ModifParcialConsulta',
      { idRelacion, textoParcial }
    );
  }

  setObservacion(idRelacion: number, observacion: string): Observable<boolean> {
    return this.http.post<boolean>(
      this.INVENTORIES_PATH + '/GuardarObservacion',
      { idRelacion, observacion }
    );
  }

  tagLocalizadoONoRelacion(idRelacion: number, localizado: boolean): Observable<boolean> {
    return this.http.get<boolean>(
      this.INVENTORIES_PATH + '/MarcarLocalizadoNoLocalizadoPorUD?idUDRelacion=' + idRelacion +
      '&localizado=' + localizado
    );
  }

  tagLocalizadoONoRelacionesContenido(idRelacion: number, localizado: boolean): Observable<boolean> {
    return this.http.get<boolean>(
      this.INVENTORIES_PATH + '/MarcarLocalizadoNoLocalizado?idUDRelacion=' + idRelacion +
      '&localizado=' + localizado
    );
  }

  searchKeyword(from: number, take: number, keyword: ElasticExpedientesByKeyword, onlyPrestados: boolean, idGrupo: string = ''): Observable<IResultadoSearch<Expedientes>> {
    return this.http.post<any>(this.INVENTORIES_PATH + '/Expedientes/GetByKeyword/' + from + '/' + take + '/' + onlyPrestados + '/' + idGrupo , keyword)
      .pipe(map((expedientes) => {
        const toReturn = IResultadoSearch.toModel<Expedientes>(JSON.stringify(expedientes), Expedientes);
        this.consultarExpedientesYaConsultados(toReturn);
        return toReturn;
      }));
  }

  consultarExpedientesYaConsultados(resultado: IResultadoSearch<Expedientes>) {
    if (resultado.total > 0 && this.activarConsultas &&
      resultado.documents.filter(p => this.listInventory.filter(x => x == p.id).length > 0).length > 0) {
      const shop = new ShoppingCart();
      shop.type = TypeShoppingCart.LOAN;
      resultado.documents.filter(p => this.listInventory.filter(x => x == p.id).length > 0).forEach(documento => {
        documento.shoppingCart = shop;
      });
    }
  }

  searchInventarioExpedientes(from: number, take: number, filter: ExpedienteFiltroDTO, onlyPrestados: boolean): Observable<IResultadoSearch<Expedientes>> {
    return this.http.post<any>(this.INVENTORIES_PATH + '/Expedientes/' + from + '/' + take + '/' + onlyPrestados, filter)
      .pipe(map((expedientes: IResultadoSearch<Expedientes>) => {
        const toReturn = IResultadoSearch.toModel<Expedientes>(JSON.stringify(expedientes), Expedientes);
        this.consultarExpedientesYaConsultados(toReturn);
        return toReturn;
      } ));
  }

  getHistorialSolicitudes(idExpediente: number): Observable<HistorialSolicitudes[]> {
    return this.http.get<HistorialSolicitudes[]>(this.INVENTORIES_PATH + '/HistorialSolicitudes/' + idExpediente)
      .pipe(map((historialesSolicitudes: HistorialSolicitudes[]) =>
        historialesSolicitudes.map((historialSolicitudes: HistorialSolicitudes) =>
          HistorialSolicitudes.toModel(JSON.stringify(historialSolicitudes)))));
  }

  goToRecordDetail(expediente: IResultadoDocument<Expedientes>,
    keyword: ElasticExpedientesByKeyword,
    expedientes: IResultadoDocument<Expedientes>[]) {
    this.recordsToViewDetails = new DetalleExpediente(expediente, keyword, expedientes);
    this.navigateToExpedientes();
  }

  goToContainers(id: number) {
    if (this.consultaOrigen > 0 && this.contenidoOrigen > 0) {
      this.notUnload = true;
    }
    this.router.navigate(['docout', { outlets: { contenido: ['contenedor', id] } }]);
  }

  goToAz(id: string) {
    if (this.consultaOrigen > 0 && this.contenidoOrigen > 0) {
      this.notUnload = true;
    }
    this.router.navigate(['docout', {
      outlets: {
        contenido: ['az', id, {
          inventoryType: 'az'
        }]
      }
    }]);
  }

  private navigateToExpedientes() {
    this.router.navigate(['docout', { outlets: { contenido: ['expediente'] } }]);
  }

  private navigateToSearchInventory() {
    this.router.navigate(['docout', { outlets: { contenido: ['inventarios'] } }]);
  }

  goToExpedientesActivandoConsultas(idSolicitud: number, idContenido: number, idDocumentos: string[]) {
    this.activarConsultas = true;
    this.consultaOrigen = idSolicitud;
    this.contenidoOrigen = idContenido;
    this.listInventory = idDocumentos;
    this.navigateToSearchInventory();
  }

  getDetalleExpediente(): DetalleExpediente {
    return this.recordsToViewDetails;
  }

  getUnidadesDocumentales(id: number, inicio: number, fin: number): Observable<UnidadDocumental> {
    return this.http.get<UnidadDocumental>(this.INVENTORIES_PATH + '/GetUDContainer/' + id + '/' + inicio + '/' + fin)
      .pipe(map(data => UnidadDocumental.toModel(JSON.stringify(data))));
  }

  goToRecordDetailById(recordId: string) {
    return this.http.get<any>(this.INVENTORIES_PATH + '/Expedientes/GetById/' + recordId)
      .subscribe((expedientes: Expedientes) => {
        const records = IResultadoSearch.toModel<Expedientes>(JSON.stringify(expedientes), Expedientes);
        if (records.documents[0].document.imagenAsociada && records.documents[0].document.imagenAsociada.GUID_miniaturas) {
          this.imagenCacheService.getImageArrayBufferByGuid(records.documents[0].document.imagenAsociada.GUID_miniaturas)
            .then((data: ArrayBuffer) => {
              records.documents[0].document.imagenAsociada.imageMiniaturaSrc = data;
            });
        }
        this.recordsToViewDetails = new DetalleExpediente(records.documents[0], null, []);
        this.navigateToExpedientes();
      });
  }

  saveFilter(filter: ExpedienteFiltroDTO): any {
    this.filter = filter;
  }

  removeFilter() {
    this.filter = undefined;
  }

  getFilter() {
    const filtro = this.filter;
    // this.removeFilter();
    return filtro;
  }

  getAzById(id: string): Observable<AzDetail> {
    return this.http.get<AzDetail>(`${this.INVENTORIES_PATH}/GetByIdAZ/${id}`)
      .pipe(map((az: any) => AzDetail.toModel(JSON.stringify(az))));
  }

  getExpedientesOfAz(id: string, inicio: number, size: number): Observable<any> {
    return this.http.post<any>(`${this.INVENTORIES_PATH}/GetExpedientesOfAZ/${id}/${inicio}/${size}`, undefined);
  }

  searchInventarioAZ(from: number, take: number, filter: FiltroAZ): Observable<{ CONTADOR: number, Documents: AzDetail[] }> {
    return this.http.post<any>(`${this.INVENTORIES_PATH}/GetByIdAZ/${from}/${take}`, filter)
      .pipe(map((azs: any) => {
        return {
          CONTADOR: azs.CONTADOR,
          Documents: [...azs.Documents].map((az: any) => AzDetail.toModel(JSON.stringify(az.Document)))
        };
      }));
  }
  changeSecurityLevel(id: string, securityLevel: number): Observable<any> {
    return this.http.post<any>(`${this.INVENTORIES_PATH}/RegularNivelSeguridadExpediente/${id}/${securityLevel}`, undefined);
  }

  changeGroupSecurityLevel(recordId: string, securityLevel: number[]): Observable<any> {
    return this.http.post<any>(`${this.INVENTORIES_PATH}/RegularGruposAccesoExpediente/${recordId}`, securityLevel);
  }

  changeImageSecurityLevel(recordId: string, imageId: string, securityLevel: number): Observable<any> {
    return this.http.post<any>(`${this.INVENTORIES_PATH}/RegularNivelSeguridadImagen/${recordId}/${imageId}/${securityLevel}`, undefined);
  }

  changePartialImageSecurityLevel(recordId: string, imageId: string, securityLevel: number): Observable<any> {
    return this.http.post<any>(`${this.INVENTORIES_PATH}/RegularNivelSeguridadImagenParcial/${recordId}/${imageId}/${securityLevel}`, undefined);
  }

  descargarDetalleExpediente(idExpediente: string): Observable<any> {
    return this.http.get(`${this.INVENTORIES_PATH}/ImpresionDetalle/${idExpediente}`, { responseType: 'blob' });
  }

  comprobarNumAzEnContenedor(numAz: number, numContenedor: number): Observable<boolean> {
    return this.http.get<boolean>(`${this.INVENTORIES_PATH}/ComprobarExisteAZ/${numAz}/${numContenedor ? numContenedor : 0}`);
  }

  setCamposRango(hayCamposRango) {
    this.camposRango = hayCamposRango;
  }

  getCamposRango(): boolean {
    return this.camposRango;
  }

  changeSearchOperator(operator: SearchOperators) {
    this.operatorByKeyword = operator;
  }

  getSearchOperator(): SearchOperators {
    return this.operatorByKeyword;
  }

  getExportFileByDocumentalSerie(serieId: number): Observable<Blob> {
    return this.http.get(this.INVENTORIES_PATH + '/ExportByDocumentalSerie/' + serieId, { responseType: 'blob' });
  }

  getExportFileByKeyword(search: ExportExpedientes): Observable<Blob> {
    return this.http.post(this.INVENTORIES_PATH + '/ExportByKeyword', search, { responseType: 'blob' });
  }

  getDevolucionConsulta(idConsulta: number): Observable<number> {
    return this.http.get<number>(this.INVENTORIES_PATH + '/DevolverConsulta?idConsulta=' + idConsulta);
  }

  getCargasInventario(desde: number, cuantos: number): Observable<VResponseBatchModule[]> {
    return this.http.get<VResponseBatchModule[]>(this.INVENTORIES_PATH + '/Carga/Consulta?desde=' + desde + '&cuantos=' + cuantos);
  }

  loadNewCargaInventario(prioritario: boolean, observaciones: string, fileData: FileData): Observable<ResponseCargaInventario> {
    const formData = new FormData();
    formData.append('fichero', fileData.file, fileData.filename);
    return this.http.post<ResponseCargaInventario>(this.INVENTORIES_PATH + '/Carga/Nueva?prioritario='
      + prioritario + '&observaciones=' + observaciones, formData);
  }

  authInventario(idCarga: number, auth: boolean): Observable<boolean> {
    return this.http.get<boolean>(this.INVENTORIES_PATH + '/Carga/Auth?idCarga=' + idCarga + '&resultadoAuth=' + auth);
  }

  public downloadFicheroCarga(hash: string): Observable<ArrayBuffer> {
    const llamada = this.PATH_DOWNLOAD + '/' + hash;
    return this.http.get(llamada, { responseType: 'arraybuffer' });
  }

  // 🥑🥑 servicio para recuperar la oficina con la referencia
  recuperarOficinaGrupo(referenciaExterna: string): Observable<GrupoOficina> {
    return this.http.get<GrupoOficina>(this.INVENTORIES_PATH + '/recuperarOficinaPorReferenciaExterna/' + referenciaExterna);
  }
  // 🥑🥑 servio para recuperar los expedientes de la series de almacen con filtros de query (searchInventarioExpedientes)
  searchExpedientesSerieAlmacen(from: number, take: number, filterExtraerSeries: ExpedienteFiltroDTO, onlyPrestados: boolean): Observable<IResultadoSearch<Expedientes>> {
    return this.http.post<any>(this.INVENTORIES_PATH + '/ExpedientesSeriesAlmacen/' + from + '/' + take + '/' + onlyPrestados, filterExtraerSeries)
      .pipe(map((expedientes: IResultadoSearch<Expedientes>) => {
        const toReturn = IResultadoSearch.toModel<Expedientes>(JSON.stringify(expedientes), Expedientes);
        this.consultarExpedientesYaConsultados(toReturn);
        return toReturn;
      }));
  }

  saveFilterExtraerSeries(filterExtraerSeries: ExpedienteFiltroDTO): any {
    this.filterExtraerSeries = filterExtraerSeries;
  }

  removeFilterExtraerSeries() {
    this.filterExtraerSeries = undefined;
  }

  getFilterExtraerSeries() {
    const filtro = this.filterExtraerSeries;
    // this.removeFilter();
    return filtro;
  }

  getExtraerSeriesFields( serieId: number): Observable<ExtraerSeriesAlmacen[]> {
    return this.http.get<ExtraerSeriesAlmacen[]>(this.INVENTORIES_PATH + '/getExtraerSeriesFields/' + serieId);
  }

  postExtraerSeriesDatosEncontrados_3(idSerie: number, camposSolicitud: CampoSolicitud[]): Observable<Blob> {
    return this.http.post<Blob>(this.INVENTORIES_PATH + '/ExtraerSeriesDatosEncontrados/' + idSerie, camposSolicitud);
  }

  postExtraerSeriesDatosEncontrados(idSerie: number, saltarFiltroSerie: boolean, camposSolicitud: CampoSolicitud[]): Observable<Blob> {
    return this.http.post(this.INVENTORIES_PATH + '/ExtraerSeriesDatosEncontrados/' + idSerie + '/' + saltarFiltroSerie, camposSolicitud, { responseType: 'blob' });
  }

  postExtraerSeriesDatosEncontrados_2(idSerie: number, camposSolicitud: CampoSolicitud[]): Observable<Blob> {
    return this.http.post(this.INVENTORIES_PATH + '/ExtraerSeriesDatosEncontrados/' + idSerie  , camposSolicitud, { responseType: 'blob' });
  }

  getnombreInformeExtraerSeriesDatosEncontrados(idSerie: number): Observable<string> {
    return this.http.get<string>(this.INVENTORIES_PATH + '/nombreInformeExtraerSeriesDatosEncontrados/' + idSerie);
  }

  postExtraerInformeClienteCaixaEspecifico(datosFechas: ResponseFechas): Observable<Blob> {
    return this.http.post(this.INVENTORIES_PATH + '/ExtraerInformeClienteCaixaEspecifico', datosFechas, { responseType: 'blob' });
  }
}
